import { Reducer } from "redux";

import { BookingsAction, BookingsActionTypes, BookingsState } from "./types";

const initialState: BookingsState = {
  count: 0,
  items: [],
  isLoading: false,
};

const reducer: Reducer<BookingsState, BookingsAction> = (state = initialState, action) => {
  switch (action.type) {
    case BookingsActionTypes.DATA_FETCH_REQUEST: {
      return { ...state, isLoading: true };
    }

    case BookingsActionTypes.DATA_FETCH_ERROR: {
      return { ...state, isLoading: false };
    }

    case BookingsActionTypes.DATA_FETCH_SUCCESS: {
      const { count, results } = action.payload;
      return { ...state, count, items: results, isLoading: false };
    }

    default:
      return state;
  }
};

export default reducer;
